/**
 * text,set the text bold or italic or underline or with strike through or subscript or superscript
 * Created by peak on 16/8/18.
 */
import dashboard from "./dashboard.vue";
export default {
    name: "text",
    icon: "custom-icon text",
    i18n: "text",
    show: true,
    dashboard
}




// WEBPACK FOOTER //
// ./src/components/editor/src/modules/text/index.js